/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getDateTime } from '../../utils/common';
import { EVENT_STATUS, PAGES } from '../../constants';

const TABLE_HEADERS = ['Match ID', 'Date', 'Status', 'Team Home', 'Score', 'Team Away', 'League', 'Season', 'Round'];

function getFormattedDateAndTime(eventDate, timezone) {
  const dateTime = getDateTime(eventDate, timezone);
  const [date, time] = dateTime.split(' ');
  const [day, month] = date.split('/');
  const formattedDate = `${day}/${month}`;

  const [hour, minute] = time.split(':');
  const formattedTime = `${hour}:${minute}`;

  return {
    date: formattedDate,
    time: formattedTime,
  };
}

function HistoricalEventsTable({
  events, leagues, timezone,
}) {
  const [openedMenu, setOpenedMenu] = useState('');

  function openContextMenu(matchId, event) {
    event.preventDefault();
    const newValue = matchId === openedMenu ? '' : matchId;
    setOpenedMenu(newValue);
  }

  function closeContextMenu() {
    setOpenedMenu('');
  }

  return (
    <table className="table-style table-style--event">
      <thead>
        <tr>
          {TABLE_HEADERS.map((header, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <th key={index}>{header}</th>
          ))}
          <th className="menu" />
        </tr>
      </thead>
      <tbody>
        {events.map((data, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={index}>
            {
              data.events.map((event) => {
                const formattedDateAndTime = getFormattedDateAndTime(event.startDateTime, timezone);

                return (
                  <tr
                    key={event.matchId}
                    className={`table-style__row status--${EVENT_STATUS[event.status]} 
                  ${event.bookedFlag ? 'table-style__row--booked' : ''} ${openedMenu === event.matchId ? 'open' : ''}`}
                    onContextMenu={openContextMenu.bind(null, event.matchId)}
                  >
                    <td>{event.matchId}</td>
                    <td>
                      {formattedDateAndTime.date}
                      {' '}
                      <span className="m-l-10">{formattedDateAndTime.time}</span>
                    </td>
                    <td className="status" />
                    <td>{event.teamHome.name}</td>
                    <td>
                      <span>{event.teamHome.score}</span>
                      <span> - </span>
                      <span>{event.teamAway.score}</span>
                    </td>
                    <td>{event.teamAway.name}</td>
                    <td>{leagues.find((l) => l.id === event.leagueId)?.name}</td>
                    <td>{event.season}</td>
                    <td>{event.round}</td>
                    <td>
                      <div className="context-menu">
                        <div className="context-menu__list">
                          <Link
                            to={`${PAGES.MATCH_TIMELINE_HISTORY}/${event.matchId}`}
                          >
                            <div className="context-menu__list-item">
                              Match timeline
                            </div>
                          </Link>
                        </div>
                        <div className="context-menu__mask" onClick={closeContextMenu} />
                      </div>
                    </td>
                  </tr>
                );
              })
            }
            {index < events.length - 1 && (
              <tr key={data.hour} className="table-style__row table-style__row--time black ">
                <td className="text-left p-l-20" colSpan="10">
                  {data.hour}
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}

export default HistoricalEventsTable;
